/** M1911. .45 ACP: seven big slow rounds, a heavy kick and a slower cadence than the Glock. */

import type { WeaponSpec } from '@/sim/weapons/weaponContract';

export const M1911 = {
  id: 'm1911',
  label: 'M1911',
  classId: 'pistol',
  caliber: '.45 ACP',
  fireMode: 'semi',
  roundsPerMinute: 330,
  magSize: 7,
  reserveAmmo: 56,
  reloadSeconds: 1.7,
  emptyReloadSeconds: 2.3,
  reloadStyle: 'magazine',
  damage: 44,
  damageTypeId: 'ballistic',
  falloff: { fullMetres: 20, zeroMetres: 100, minScale: 0.3 },
  pellets: 1,
  adsSpreadMoa: 4.5,
  hipSpreadMoa: 95,
  bloomMoaPerShot: 16,
  bloomMoaCap: 70,
  bloomDecayMoaPerSecond: 85,
  moveSpreadMoaPerMps: 15,
  crouchSpreadScale: 0.75,
  airborneSpreadMoa: 65,
  recoilPattern: [
    { pitch: 1.5, yaw: 0.1 },
    { pitch: 1.45, yaw: -0.2 },
    { pitch: 1.4, yaw: 0.15 },
  ],
  recoilResetSeconds: 0.45,
  recoilRecoveryPerSecond: 7,
  adsFovDegrees: 55,
  adsSeconds: 0.2,
  adsSensitivityScale: 0.75,
  muzzleVelocity: 250,
} as const satisfies WeaponSpec;
